import React from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ISocietiesModel } from '../../../../../interfaces/models/societies.interfaces'
import {
  ITicket,
  ITicketBoard,
} from '../../../../../interfaces/models/ticket.interfaces'
import {
  infiniteTicketQueries,
  ticketQueries,
  updateTicketStatus,
} from '../../../../../api/ticket'
import {
  Button,
  ButtonVariant,
} from '../../../../../components/common/Button/Button'
import { useAppTranslation } from '../../../../../hooks/useAppTranslation'

export const SetStatusOnTicket = ({
  society,
  ticket,
  className,
}: {
  society: ISocietiesModel
  className?: string
  ticket: ITicketBoard
}): React.ReactNode => {
  const queryClient = useQueryClient()
  const { mutate, isPending } = useMutation({
    mutationFn: async ({ status }: { status: ITicket['status'] }) => {
      await updateTicketStatus(
        { societyId: society._id, ticketId: ticket.id },
        {
          status,
        }
      )
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: infiniteTicketQueries.ticketsBoard({
            societyId: society._id,
          }).queryKey,
        }),
        queryClient.invalidateQueries({
          queryKey: ticketQueries.getTicketAsBoard(ticket.id, society._id)
            .queryKey,
        }),
      ])
    },
  })
  const { translate } = useAppTranslation()

  const handleToggleStatus = (): void => {
    if (ticket.status === 'open') {
      return mutate({ status: 'closed' })
    }
    return mutate({ status: 'open' })
  }

  const label =
    ticket.status === 'open'
      ? translate('ticketBoardSidebar.status.close')
      : translate('ticketBoardSidebar.status.open')

  return (
    <Button
      className={className}
      variant={ButtonVariant.DANGER}
      label={label}
      onClick={handleToggleStatus}
      disabled={isPending}
    />
  )
}
